export const OPEN_DELETE_COMMENT_MODAL = 'OPEN_DELETE_COMMENT_MODAL';
export const DELETE_TIMELINE_COMMENT = 'DELETE_TIMELINE_COMMENT';